import './education.css';
import '../../css/flags.css';



(function($) {
    let scrolling = false;
    let fxEcalendarContainer = $('#fxEcalendar');
    let liveRatesContainer = $('#live-rates-widget');

    let  loadingfxEcalendar = false , 
    fxEcalendarLoaded = false, 
    loadingLiveRates = false , 
    liveRatesLoaded = false 

    function doScrolling() {

        if (!loadingfxEcalendar && fxEcalendarContainer.length > 0 && fxEcalendarContainer.html().trim() === '' && window.isInViewport(fxEcalendarContainer)) {
            loadingfxEcalendar = true;
            !fxEcalendarLoaded && import(/* webpackChunkName: "fxEcalendar" */'../fxEcalendar/fxEcalendar')
                .then(() => {
                    loadingfxEcalendar = false;
                    fxEcalendarLoaded = true;
                    window.fxEcalendar({curr_lang:window.tm_language,importance:'3', maxRows:'6'});
                });
        }

        
        if (!loadingLiveRates && liveRatesContainer.length > 0 && window.isInViewport(liveRatesContainer)) {
            loadingLiveRates = true;
            !liveRatesLoaded && import(/* webpackChunkName: "liveRatesWidget" */'../liveRatesWidget/liveRatesWidget.js')
                .then(module => {
                    loadingLiveRates = false;
                    liveRatesLoaded = true;
                    module.default;
                });
        }
    }

    window.scrollingTasks.push(doScrolling);

})(window.jQuery);